<template>
    <div>
        <e-dialog
                dialogTitle="驳回确认"
                :centerDialogVisible="visible"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'400px'">
            <div>
                <div class="reason">请填写驳回原因</div>
                <el-input class="text-area" type="textarea" v-model="rejectReason" maxlength="300"
                          show-word-limit></el-input>
            </div>
        </e-dialog>
    </div>
    
</template>

<script>
    import eDialog from "../../../components/common/e-dialog.vue";

    export default {
        name: "rejectDialog",
        components:{eDialog},
        props:{
            visible:{
                type:Boolean,
                default:false
            },
        },
        data(){
            return{
                rejectReason:''
        }},
        methods:{
            resetPopupData(){
                this.$emit('closeDialog');
            },
            submitPopupData(){
                if(!this.rejectReason){
                    return  this.$message.error('请输入驳回原因。')
                }
                this.$emit('submitPopupData',this.rejectReason);
                this.rejectReason = '';
                this.$emit('closeDialog');
            },
        },
    }
</script>

<style scoped lang="scss">
    .reason{
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
     }
</style>